import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { ArtistList } from 'components/models/artists/ArtistList'
import { Loading } from 'components/shared/Loading'
import { useOwnerArtistNames } from 'hooks/owners'
import { isEmpty } from 'lodash'
import Image from 'next/image'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  owner: Owner
}

export const ArtistTab: FC<Props> = ({ owner }) => {
  const { data: artists, isValidating: isValidatingArtists } =
    useOwnerArtistNames({ ownerId: owner.id, limit: 100 })
  const { xs } = useBreakpoint()
  const { t } = useTranslation()

  if (isValidatingArtists) {
    return (
      <div style={{ paddingTop: xs ? 32 : 60 }}>
        <Loading />
      </div>
    )
  }

  if (isEmpty(artists)) {
    return (
      <div
        style={{
          paddingTop: 100,
          paddingBottom: 100,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 24,
          justifyContent: 'center',
        }}
      >
        <Image src="/no-objects/artist.png" width={130} height={130} />
        <Typography.Text style={{ fontSize: 16, lineHeight: 1 }}>
          {t('公開アーティストはいません')}
        </Typography.Text>
      </div>
    )
  }

  return (
    <div style={{ padding: xs ? '32px 16px 24px' : '60px 57px 46px' }}>
      {artists && <ArtistList artists={artists} />}
    </div>
  )
}
